var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListZoomTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_12522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_12522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7519 17C3.53885 17 3.36028 16.9285 3.21617 16.7856C3.07206 16.6427 3 16.4656 3 16.2544C3 16.0431 3.07188 15.8646 3.21563 15.7188C3.35938 15.5729 3.5375 15.5 3.75 15.5H4.5V3.75C4.5 3.5375 4.57202 3.35937 4.71606 3.21562C4.86012 3.07187 5.03861 3 5.25154 3H11.2639C11.4769 3 11.6528 3.07187 11.7917 3.21562C11.9306 3.35937 12 3.5375 12 3.75V4H14.7708C14.9653 4 15.1354 4.07292 15.2812 4.21875C15.4271 4.36458 15.5 4.53472 15.5 4.72917V15.5H16.2708C16.4833 15.5 16.6615 15.5715 16.8052 15.7144C16.949 15.8573 17.0208 16.0344 17.0208 16.2456C17.0208 16.4569 16.9485 16.6354 16.804 16.7812C16.6594 16.9271 16.4803 17 16.2666 17H14.7581C14.5444 17 14.3646 16.9301 14.2188 16.7904C14.0729 16.6506 14 16.4774 14 16.2708V5.5H12V16.2708C12 16.4653 11.9271 16.6354 11.7812 16.7812C11.6354 16.9271 11.4653 17 11.2708 17H3.7519ZM9.75 10.0044C9.75 9.79313 9.67855 9.61458 9.53565 9.46875C9.39273 9.32292 9.21565 9.25 9.0044 9.25C8.79313 9.25 8.61458 9.32145 8.46875 9.46435C8.32292 9.60727 8.25 9.78435 8.25 9.9956C8.25 10.2069 8.32145 10.3854 8.46435 10.5312C8.60727 10.6771 8.78435 10.75 8.9956 10.75C9.20687 10.75 9.38542 10.6785 9.53125 10.5356C9.67708 10.3927 9.75 10.2156 9.75 10.0044ZM6 15.5H10.5V4.5H6V15.5Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListZoomTeams);
export default __webpack_public_path__ + "static/media/listZoomTeams.ba2ed724fdbd99c10fdcc9ea003ce8d7.svg";
export { ForwardRef as ReactComponent };